module.exports = __webpack_public_path__ + "assets/img/online_24h.63812177.svg";